export const TRANSACTION_CONTAINER_TAG_NAME = 'transaction-container';
